import React from 'react';
import PropTypes from 'prop-types';
import Tabs from '../../components/ui/VideoTabs';

const CategorySection = ({ activeCategory, setActiveCategory }) => {
  const categories = [
    { label: 'Variety', id: 'variety', disabled: true },
    { label: 'Origin', id: 'origin', disabled: false },
    { label: 'Properties', id: 'properties', disabled: true },
    { label: 'Price Range', id: 'price-range', disabled: true },
  ];

  const handleCategoryChange = (index) => {
    setActiveCategory(categories[index].id);
  };

  const handleMobileCategoryChange = (e) => {
    setActiveCategory(e.target.value);
  };

  return (
    <section className="mt-12  mb-8">
      <div className="container mx-auto px-4">
        {/* Mobile Dropdown */}
        <div className="block md:hidden">
          <select
            id="category-select"
            value={activeCategory}
            onChange={handleMobileCategoryChange}
            className="w-full p-2 border border-gray-300 rounded-md"
          >
            {categories.map((category, index) => (
              <option key={index} value={category.id} disabled={category.disabled}>
                {category.label}
              </option>
            ))}
          </select>
        </div>

        {/* Desktop Tabs */}
        <div className="hidden md:flex justify-center">
          <Tabs
            tabs={categories}
            activeTab={
              categories.findIndex((cat) => cat.id === activeCategory) !== -1
                ? categories.findIndex((cat) => cat.id === activeCategory)
                : 0
            }
            onChange={handleCategoryChange}
          />
        </div>
      </div>
    </section>
  );
};

CategorySection.propTypes = {
  activeCategory: PropTypes.string.isRequired,
  setActiveCategory: PropTypes.func.isRequired,
};

export default CategorySection;
